export const sliderFotos = [
  "/Images/PreWedding/1.jpg",
  "/Images/PreWedding/2.jpg",
  "/Images/PreWedding/3.jpg",
  "/Images/PreWedding/4.jpg",
  "/Images/PreWedding/5.jpg",
  "/Images/PreWedding/6.jpg",
  "/Images/PreWedding/7.jpg",
  "/Images/PreWedding/8.jpg",
  "/Images/PreWedding/9.jpg",
  "/Images/PreWedding/10.jpg",
  "/Images/PreWedding/11.jpg",
  "/Images/PreWedding/12.jpg",
  "/Images/PreWedding/13.jpg",
  "/Images/PreWedding/14.jpg",
  "/Images/PreWedding/15.jpg",
  "/Images/PreWedding/16.jpg",
  "/Images/PreWedding/17.jpg",
  "/Images/PreWedding/18.jpg",
  "/Images/PreWedding/19.jpg",
  "/Images/PreWedding/20.jpg",
  "/Images/PreWedding/21.jpg",
  "/Images/PreWedding/22.jpg",
  "/Images/PreWedding/23.jpg",
  "/Images/PreWedding/24.jpg",
  "/Images/PreWedding/25.jpg",
  "/Images/PreWedding/26.jpg",
  "/Images/PreWedding/27.jpg",
  "/Images/PreWedding/28.jpg",
  "/Images/PreWedding/29.jpg",
  "/Images/PreWedding/30.jpg",
  "/Images/PreWedding/31.jpg",
  "/Images/PreWedding/32.jpg",
  "/Images/PreWedding/33.jpg",
  "/Images/PreWedding/34.jpg",
  "/Images/PreWedding/35.jpg",
  "/Images/PreWedding/36.jpg",
  "/Images/PreWedding/37.jpg",
  "/Images/PreWedding/38.jpg",
  "/Images/PreWedding/39.jpg",
  "/Images/PreWedding/40.jpg",
  "/Images/PreWedding/41.jpg",
  "/Images/PreWedding/42.jpg",
  "/Images/PreWedding/43.jpg",
  "/Images/PreWedding/44.jpg",
  "/Images/PreWedding/45.jpg",
  "/Images/PreWedding/46.jpg",
  "/Images/PreWedding/47.jpg",
  "/Images/PreWedding/48.jpg",
  "/Images/PreWedding/49.jpg",
  "/Images/PreWedding/50.jpg",
  "/Images/PreWedding/51.jpg",
  "/Images/PreWedding/52.jpg",
  "/Images/PreWedding/53.jpg",
  "/Images/PreWedding/54.jpg",
  "/Images/PreWedding/55.jpg",
  "/Images/PreWedding/56.jpg"
];
